import React from 'react';
import { About } from '../components/About';
export function AboutPage() {
  return <main data-id="element-1064">
      <About data-id="element-1065" />
    </main>;
}